import EmailNotification from 'models/notification/email/EmailNotification';

/**
 * Class representing a submission rejected status email notification.
 * @extends EmailNotification
 */
export default class SubmissionRejectedEmailNotification extends EmailNotification {
	_type = 'submission-rejected';
}
